import {Box, styled} from '@mui/material';

const StyledBox = styled(Box)`
	border-radius: 8px;
	padding: 24px;
	background-repeat: no-repeat;
	background-position: bottom;
	background-size: cover;
`;

export {StyledBox};
